import CitySEOHead from "@/components/feature/CitySEOHead";
import LincolnHeroSection from "./components/HeroSection";
import LincolnStickyNav from "./components/StickyNav";
import LincolnProcessingTimeSection from "./components/ProcessingTimeSection";
import LincolnServicesSection from "./components/ServicesSection";
import LincolnLocalAreaSection from "./components/LocalAreaSection";
import LincolnTestimonialsSection from "./components/TestimonialsSection";
import LincolnAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LincolnComparisonSection from "./components/ComparisonSection";
import LincolnMistakesSection from "./components/MistakesSection";
import LincolnHowItWorksSection from "./components/HowItWorksSection";
import LincolnFAQSection, { faqs } from "./components/FAQSection";
import LincolnHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LincolnFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import LincolnTravelTimingSection from "./components/TravelTimingSection";
import LincolnDestinationsSection from "./components/DestinationsSection";

const lincolnServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function LincolnPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Lincoln"
        state="Nebraska"
        stateAbbr="NE"
        route="/cities/lincoln"
        title="Emergency Passport Lincoln, NE — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Lincoln, NE — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving UNL students studying abroad, Capitol staff on trade missions, Bryan Health medical professionals, and Southeast Nebraska families."
        geoPlacename="Lincoln, Nebraska"
        geoPosition="40.8136;-96.7026"
        faqs={faqs}
        servicesSchema={lincolnServices}
        statePageName="Nebraska"
        statePageRoute="/states/nebraska"
      />
      <LincolnHeroSection />
      <LincolnStickyNav />
      <LincolnProcessingTimeSection />
      <LincolnServicesSection />
      <LincolnLocalAreaSection />
      <LincolnTravelTimingSection />
      <LincolnDestinationsSection />
      <LincolnTestimonialsSection />
      <LincolnAcceptanceFacilitiesSection />
      <LincolnComparisonSection />
      <LincolnMistakesSection />
      <LincolnHowItWorksSection />
      <LincolnFAQSection />
      <LincolnHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lincoln" state="NE" />
      <LincolnFinalCTA />
    </div>
  );
}